import { render, staticRenderFns } from "./SwitchTree.vue?vue&type=template&id=26886c9b&scoped=true&"
import script from "./SwitchTree.vue?vue&type=script&lang=js&"
export * from "./SwitchTree.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTree.vue?vue&type=style&index=0&id=26886c9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26886c9b",
  null
  
)

export default component.exports